export default __webpack_public_path__ + "static/media/medianPrice.b9c4f3dd.svg";